import React from 'react'
import { dateTimeText, utcText } from './local-time'

// An absolute time as a page shows one (local-time.js): the viewer's own,
// with its zone ("Oct 8, 2026 at 11:20 AM MDT"), and the precise UTC
// instant on hover. Nothing for no time.
export const LocalTime = ({ value, seconds = false, tz, className }) => {
  const text = dateTimeText(value, { seconds, ...(tz ? { tz } : {}) })
  if (!text) return null
  return <time className={className} dateTime={new Date(value).toISOString()} title={utcText(value)}>{text}</time>
}
